<!--家长预约-->
<template>
  <div class="page-appointment">
    <!--悬浮头部-->
    <Header></Header>
    <!--banner-->
    <div class="banner">
      <img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/news_banner.jpg" /> 
      <ul class="content">
         <li @click.stop="showChange('0')" :class="{'active':tab=='0'}">
          <i class="iconfont icon-signUp"></i>
          <div class="title"><p>SignUp</p><p>家长预约</p></div>
        </li>
        <li v-show="tab=='1'"  @click.stop="showChange('1')" :class="{'active':tab=='1'}">
          <i class="iconfont icon-news"></i>
          <div class="title"><p>News</p><p>新闻动态</p></div>
        </li>
      </ul>
    </div>
    <!--家长预约-->
    <Parents v-show="tab=='0'"></Parents>
    <!--新闻状态-->
    <StateNews v-show="tab=='1'"></StateNews>
   <!--底部-->
   <v-footer></v-footer>
  </div>
</template>

<script>
import Header from '@/components/header/Header' //悬浮头部
import Parents from '@/pages/appointment/parents' //家长预约模块
import StateNews from '@/pages/appointment/stateOfnews' //新闻状态
import Footer from '@/components/footer/footer'//底部模块
export default {
   data(){
     return{
       tab: this.$route.query.id,
     }
   },
  components: {
    Header,
    Parents,
    StateNews,
    'v-footer':Footer
  },
  mounted(){
    this.$nextTick(() => {
     
    })
  },
  methods:{
     showChange(val){
       this.tab = val;
     }
  }
}

</script>
<style rel="stylesheet/scss" lang="scss">
 @import "@/assets/css/variables.scss";
 .page-appointment{
   .banner{
     width: 100%;
     position: relative;
     img{
       display: block;
       width: 100%;
     }
     .content{
       position: absolute;
       left:50%;
       margin-left:-600px;
       bottom:0;
       height: 100px;
       li{
        position: relative;
        width:390px;
        height: 100px;
        float:left;
        background:rgba(0,0,0,0.6);
        margin-right:10px;
        cursor: pointer;
        i.iconfont{
          display: block;
          width: 80px;
          height: 80px;
          margin-left:72px;
          margin-top: 15px;
          float:left;
        }
        i.iconfont.icon-signUp{
          background: url(../../assets/image/icon.png) no-repeat;
          background-position: -110px -10px;
        }
         i.iconfont.icon-news{
          background: url(../../assets/image/icon.png) no-repeat;
          background-position: -10px -10px;
        }
        div.title{
          float:left;
          margin-top: 15px;
          margin-left:35px;
          p{
            width: 100%;
            font-size: 18px;
            color: #ffffff;
            margin-top: 10px;
          }
           p:first-child{
             font-size: 20px;
             font-family:TimesNewRomanPSMT;
           }
        }
      }
      .active{
        background:rgba(0,40,93,1);
      }
      li:hover{
        background:rgba(0,40,93,1);
      }
     }
   }
 }
@media (max-width: 767px) { 
  .page-appointment{
   .banner{
     padding-top: 45px;
     .content{
       position: absolute;
       left:0;
       margin-left:0;
       bottom:0;
       display: flex;
       height: 52px;
       width: 100%;
       li{
        width: 50%;
        height: 52px;
        background:#003478;
        opacity:0.85;
        clear: both;
        display: flex;
        align-items: center;
        justify-content: center;
        i.iconfont{
          margin: 0;
          display: block;
          width: 35px;
          height: 33px;
          margin-right: 5px;
        }
        i.iconfont.icon-signUp{
          background: url(../../assets/image/icon.png) no-repeat;
          background-position: -47px -5px;
          background-size: 700px 700px;
        }
         i.iconfont.icon-news{
          background: url(../../assets/image/icon.png) no-repeat;
          background-position: -2px -6px;
          background-size: 700px 700px;
        }
        div.title{
          margin: 0;
          p{
            margin: 0;
            font-size:9px;
            font-family:SourceHanSansCN-Regular;
            -webkit-text-size-adjust:none;
            font-weight:400;
            color:rgba(255,255,255,1);
            line-height:10px;
          }
           p:first-child{
              font-size:10px;
              font-family:TimesNewRomanPSMT;
              padding-bottom: 4px;
           }
        }
      }
      .active{
        background:rgba(0,40,93,1);
      }
      li:hover{
        background:rgba(0,40,93,1);
      }
     }
   }
 }
}
</style>


// WEBPACK FOOTER //
// src/pages/appointment/appointment.vue